// @flow

import React, { PureComponent, Fragment } from "react";
import {
  LeftWrapper,
  RightWrapper,
  Position,
  Number,
  Runner,
  WagerType,
  RaceResultsHeaderContainer,
  OddsTitle
} from "./styled-components";

type Props = {
  hasRunner: boolean,
  hasWin: boolean,
  hasPlace: boolean,
  hasShow: boolean,
  hasDistance: boolean,
  hasOdds: boolean,
  hasTopBorder: boolean,
  simpleVersion: boolean,
  winAmount: number,
  placeAmount: number,
  showAmount: number
};

export default class RaceResultsHeader extends PureComponent<Props> {
  static defaultProps = {
    hasRunner: true,
    hasWin: true,
    hasPlace: true,
    hasShow: true,
    hasDistance: false,
    hasOdds: false,
    hasTopBorder: false,
    simpleVersion: false,
    winAmount: 0,
    placeAmount: 0,
    showAmount: 0
  };

  renderWagerTypes = () => (
    <Fragment>
      {this.props.hasWin && (
        <WagerType data-qa-label="raceResultsHeader-betType-win">
          {this.props.winAmount ? `$${this.props.winAmount} WIN` : "WIN"}
        </WagerType>
      )}
      {this.props.hasPlace && (
        <WagerType data-qa-label="raceResultsHeader-betType-place">
          {this.props.placeAmount
            ? `$${this.props.placeAmount} PLACE`
            : "PLACE"}
        </WagerType>
      )}
      {this.props.hasShow && (
        <WagerType data-qa-label="raceResultsHeader-betType-show">
          {this.props.showAmount ? `$${this.props.showAmount} SHOW` : "SHOW"}
        </WagerType>
      )}
    </Fragment>
  );

  render() {
    const { simpleVersion, hasTopBorder } = this.props;
    return (
      <RaceResultsHeaderContainer
        hasTopBorder={hasTopBorder}
        data-qa-label="raceResultsHeader"
      >
        <LeftWrapper>
          <Position>{simpleVersion ? "POSITION" : "POS"}</Position>
          {!simpleVersion && <Number>#</Number>}
          {!simpleVersion && this.props.hasRunner && (
            <Runner data-qa-label="raceResultsHeader-runner">HORSE</Runner>
          )}
        </LeftWrapper>
        <RightWrapper>
          {simpleVersion ? (
            <OddsTitle>STARTING PRICE</OddsTitle>
          ) : (
            this.renderWagerTypes()
          )}
        </RightWrapper>
      </RaceResultsHeaderContainer>
    );
  }
}
